import Vue from 'vue'
import App from './App.vue'

import AppSwiper from './components/Swiper'
import AppHeader from './components/Header'
import AppNav from './components/Nav'
import AppLogo from './components/Logo'
import AppBurger from './components/Burger'
import AppLang from './components/Lang'
import AppFooter from './components/Footer'

Vue.component('AppSwiper', AppSwiper)
Vue.component('AppHeader', AppHeader)
Vue.component('AppNav', AppNav)
Vue.component('AppLogo', AppLogo)
Vue.component('AppBurger', AppBurger)
Vue.component('AppLang', AppLang)
Vue.component('AppFooter', AppFooter)


import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)


import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
    en: {
        message: {
            contact: 'Contact Us',
            slogan: 'Your premier collaborative partner',
            slogan_actions: 'Innovate | Create | Appreciate',
            real_estate: 'Real Estate Agency',
            housekeeping: 'Lifestyle management',
            it_solutions: 'IT Solutions',
            menu: "menu"
        }
    },
    lv: {
        message: {
            contact: 'Mūsu kontakti',
            slogan: 'Jūsu premium klases partneris',
            slogan_actions: 'Innovate | Create | Appreciate',
            real_estate: 'Nekustamā īpašuma aģentūra',
            housekeeping: 'Lifestyle menedžments',
            it_solutions: 'IT risinājumi',
            menu: "menu"
        }
    },
    ru: {
        message: {
            contact: 'Наши контакты',
            slogan: 'Ваш высококлассный партнер',
            slogan_actions: 'Innovate | Create | Appreciate',
            real_estate: 'Агенство недвижимости',
            housekeeping: 'Lifestyle менеджмент',
            it_solutions: 'Индивидуальные ИТ-решения',
            menu: "меню"
        }
    }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})

// Create a Vue instance with `i18n` option
new Vue({
    el: '#app',
    i18n,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js